/* eslint-disable filename-export/match-named-export */

import { lazy } from "react";

import { redirectContinueApplicationLoader } from "@/components/RedirectContinueApplication/loader";
import { env } from "~/env";
import PrivateRoute from "../components/PrivateRoute";
import { checkAuthLoader } from "./lib/checkAuthLoader";

const RedirectContinueApplication = lazy(
  () => import("../components/RedirectContinueApplication")
);
const Registration = lazy(() => import("../components/Registration"));
const RegistrationRefusal = lazy(
  () => import("../components/RegistrationRefusal")
);
const RegistrationNumberConfirmation = lazy(
  () => import("../components/RegistrationNumberConfirmation")
);
const Authorization = lazy(() => import("../components/Authorization"));
const AuthorizationNumberConfirm = lazy(
  () => import("../components/AuthorizationNumberConfirm")
);
const AuthorizationBlockingCounter = lazy(
  () => import("../components/AuthorizationBlockingCounter")
);
const ChangeNumber = lazy(() => import("../components/ChangeNumber"));
const ChangeNumberSuccess = lazy(
  () => import("../components/ChangeNumber/ChangeNumberSuccess")
);
const LandingPage = lazy(() => import("../components/LandingPage/LandingPage"));
const RegistrationEsia = lazy(() => import("../components/RegistrationEsia"));
const RegistrationTinkoffID = lazy(
  () => import("../components/RegistrationTinkoffID")
);
const AgreementPartnerService = lazy(
  () => import("../components/AgreementPartnerService")
);
const ErrorPage404 = lazy(() => import("../components/ErrorPage404"));

const RegistrationTimer = lazy(() => import("../components/RegistrationTimer"));
const NewApplicationPassport = lazy(
  () => import("../components/NewApplicationPassport/NewApplicationPassport")
);
const NewApplicationAddress = lazy(
  () => import("../components/NewApplicationAddress/NewApplicationAddress")
);
const NewApplicationPlaceWork = lazy(
  () => import("../components/NewApplicationPlaceWork/NewApplicationPlaceWork")
);
const NewApplicationAdditionalQuestions = lazy(
  () => import("../components/NewApplicationAdditionalQuestions")
);
const NewApplicationNumberConfirm = lazy(
  () => import("../components/NewApplicationNumberConfirm")
);
const SelectFinInstrument = lazy(
  () => import("../components/SelectFinInstrument")
);
const NewApplicationDocsUploading = lazy(
  () =>
    import(
      "../components/NewApplicationDocsUploading/NewApplicationDocsUploading"
    )
);
const ApplicationSigning = lazy(() => import("@/pages/signing"));
const NewApplicationDocsUploadingSigned = lazy(
  () =>
    import(
      "../components/NewApplicationDocsUploadingSigned/NewApplicationDocsUploadingSigned"
    )
);
const ReapplicationConfirmation = lazy(
  () => import("../components/ReapplicationConfirmation")
);
const NewApplicationTimer = lazy(
  () => import("../components/NewApplicationTimer")
);
const AccessDenied = lazy(() => import("../components/AccessDenied"));
const { changeNumberLoader } = lazy(
  () => import("../components/ChangeNumber/loader")
);
const { newApplicationLoader } = lazy(
  () => import("../components/NewApplicationAddress/loader")
);

const InnForm = lazy(() => import("../components/InnForm"));

const VASPaymentByBankDetailsPage = lazy(
  () => import("@/pages/VASPaymentByBankDetails")
);

const WelcomePage = lazy(() => import("@/pages/Welcome"));

export const routes = [
  {
    path: "/",
    element: <LandingPage />,
    title: "LandingPage",
  },
  {
    path: "/welcome",
    element: <WelcomePage />,
    title: "Добро пожаловать",
  },
  {
    path: "/redirect-continue-application",
    element: <RedirectContinueApplication />,
    title: "Redirect",
    loader: redirectContinueApplicationLoader,
  },
  {
    path: "/registration",
    element: <Registration />,
    loader: checkAuthLoader,
    title: "Регистрация клиента",
    description: `Страница регистрации нового клиента в компании ${env.VITE_MFO_NAME_LONG}`,
  },
  {
    path: "/authorization",
    element: <Authorization />,
    loader: checkAuthLoader,
    title: "Войти в личный кабинет заемщика",
    description: `Войти в личный кабинет ${env.VITE_MFO_NAME_SHORT}. Вход по номеру телефона для управления вашим займом онлайн.`,
  },
  {
    path: "/registration-refusal",
    element: <RegistrationRefusal />,
    title: "Завершение регистрации невозможно",
  },
  {
    path: "/registration-number-confirmation",
    element: <RegistrationNumberConfirmation />,
    title: "Подтвердите мобильный телефон",
  },
  {
    path: "/authorization-number-confirmation",
    element: <AuthorizationNumberConfirm />,
    title: "Подтвердите мобильный телефон",
  },
  {
    path: "/authorization-blocking-counter",
    element: <AuthorizationBlockingCounter />,
    title: "Authorization blocking counter",
  },
  {
    path: "/change-phone/success",
    element: <ChangeNumberSuccess />,
    title: "Change number success",
  },
  {
    path: "/change-phone",
    element: <ChangeNumber />,
    title: "Оставьте заявление на смену номера",
    loader: changeNumberLoader,
  },
  {
    path: "/registration-esia",
    element: <RegistrationEsia />,
    title: "Регистрация Госуслуги",
  },
  {
    path: "/registration-tinkoff",
    element: <RegistrationTinkoffID />,
    title: "Регистрация Т-Банк",
  },
  {
    path: "/agreement",
    element: <AgreementPartnerService />,
    title: "Согласия",
  },
  {
    path: "/access-denied",
    element: <AccessDenied />,
    title: "Ошибка уникальности",
  },
  {
    path: "*",
    element: <ErrorPage404 />,
    title: "404 страница",
  },

  {
    path: "/",
    element: <PrivateRoute />,
    children: [
      {
        path: "/registration-timer",
        element: <RegistrationTimer />,
        title: "Блокировка ввода СМС-кода",
      },
      {
        path: "/new_application-passport",
        element: <NewApplicationPassport />,
        title: "Паспортные данные",
      },
      {
        path: "/new_application-address",
        element: <NewApplicationAddress />,
        title: "Адрес",
        loader: newApplicationLoader,
      },
      {
        path: "/new_application-place-work",
        element: <NewApplicationPlaceWork />,
        title: "Сведения о доходах и расходах",
      },
      {
        path: "/new_application-additional-questions",
        element: <NewApplicationAdditionalQuestions />,
        title: "Дополнительные вопросы",
      },
      {
        path: "/new_application-number-confirmation",
        element: <NewApplicationNumberConfirm />,
        title: "Подтверждение данных",
      },
      {
        path: "/new_application-select-map",
        element: <SelectFinInstrument />,
        title: "Введите данные карты",
      },
      {
        path: "/new_application-docs-uploading",
        element: <NewApplicationDocsUploading />,
        title: "Загрузите фото паспорта",
      },
      {
        path: "/new_application-inn",
        element: <InnForm />,
        title: "Укажите ИНН",
      },
      {
        path: "/new_application-signing",
        element: <ApplicationSigning />,
        title: "Подпишите документы",
      },
      {
        path: "/new_application-docs-uploading-signed",
        element: <NewApplicationDocsUploadingSigned />,
        title: "Загрузите фото паспорта",
      },
      {
        path: "/reapplication-confirmation",
        element: <ReapplicationConfirmation />,
        title: "Ваши данные",
      },
      {
        path: "/reapplication-number-confirmation",
        element: <NewApplicationNumberConfirm />,
        title: "Подтверждение данных",
      },
      {
        path: "/reapplication-method-obtaining",
        element: <SelectFinInstrument />,
        title: "Введите данные карты",
      },
      {
        path: "/reapplication-docs-uploading",
        element: <NewApplicationDocsUploading />,
        title: "Загрузите фото паспорта",
      },
      {
        path: "/reapplication-signing",
        element: <ApplicationSigning />,
        title: "Подпишите документы",
      },
      {
        path: "/reapplication-docs-uploading-signed",
        element: <NewApplicationDocsUploadingSigned />,
        title: "Загрузите фото паспорта",
      },
      {
        path: "/new_application-timer",
        element: <NewApplicationTimer />,
        title: "Ваша заявка на рассмотрении",
      },
      {
        path: "/vas-payment",
        element: <VASPaymentByBankDetailsPage />,
        title: "Оплата дополнительной услуги",
      },
    ],
  },
];
